import {
    TrueBase,
    css,
    html
} from  "../TrueBase/TrueBase";

export class TrueFooter extends TrueBase {
    static get properties() {
        return {

        }
    }

    constructor() {
        super();
    }

    render() {
        return html `
            <footer>
                <slot></slot>
            </footer>  
        `
    }

    static get styles() {
        return [super.styles, css `
            :host {
                display: block;
                --section-margin: 0;
            }

            footer {
                border-top: var(--footer-border-top, none);
                background: var(--footer-background, #f0f0f0);
            }
        `];
    }
}

window.customElements.get("true-footer") || window.customElements.define('true-footer', TrueFooter);